(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tyvexo-about"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initReveal() {
    var items = document.querySelectorAll('.tyvexo-about__reveal');
    if (!items.length || !window.IntersectionObserver) {
      items.forEach(function (el) { el.classList.add('tyvexo-about--visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('tyvexo-about--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -32px 0px' }
    );

    items.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tyvexo-checklist"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.tyvexo-checklist');
  if (!sections.length) return;

  sections.forEach(function (section) {
    var els = section.querySelectorAll('.tyvexo-checklist__reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { observer.observe(el); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tyvexo-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFaq() {
    var items = document.querySelectorAll('.tyvexo-faq__item');
    if (!items.length) return;

    items.forEach(function (item) {
      var trigger = item.querySelector('.tyvexo-faq__trigger');
      if (!trigger || trigger.dataset.tyvexoFaqBound) return;
      trigger.dataset.tyvexoFaqBound = 'true';

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('tyvexo-faq--open');

        items.forEach(function (el) {
          el.classList.remove('tyvexo-faq--open');
          var t = el.querySelector('.tyvexo-faq__trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('tyvexo-faq--open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaq);
  } else {
    initFaq();
  }
  document.addEventListener('shopify:section:load', initFaq);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tyvexo-gift-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__tyvexoGiftReveal) return;
  window.__tyvexoGiftReveal = true;

  function init() {
    var els = document.querySelectorAll('.tyvexo-gift__reveal');
    if (!els.length) return;

    if (!window.IntersectionObserver) {
      els.forEach(function (el) { el.classList.add('tyvexo-gift--visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tyvexo-gift--visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { obs.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tyvexo-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__tyvexoHeroReveal) return;
  window.__tyvexoHeroReveal = true;

  function init() {
    var els = document.querySelectorAll('.tyvexo-hero__reveal');
    if (!els.length) return;
    els.forEach(function (el) {
      requestAnimationFrame(function () {
        el.classList.add('tyvexo-hero--visible');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tyvexo-lifestyle-moment"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__tyvexoLifestyleReveal) return;
  window.__tyvexoLifestyleReveal = true;

  function init() {
    var els = document.querySelectorAll('.tyvexo-lifestyle__reveal');
    if (!els.length) return;

    if (!window.IntersectionObserver) {
      els.forEach(function (el) { el.classList.add('tyvexo-lifestyle--visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tyvexo-lifestyle--visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    els.forEach(function (el) { obs.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tyvexo-manifesto"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__tyvexoManifestoReveal) return;
  window.__tyvexoManifestoReveal = true;

  function init() {
    var els = document.querySelectorAll('.tyvexo-manifesto__reveal');
    if (!els.length) return;

    if (!window.IntersectionObserver) {
      els.forEach(function (el) { el.classList.add('tyvexo-manifesto--visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tyvexo-manifesto--visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { obs.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tyvexo-premium-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('.tyvexo-social');
  if (!section) return;

  var reveals = section.querySelectorAll('.tyvexo-social__reveal');
  if (!reveals.length) return;

  if (window.IntersectionObserver) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tyvexo-social--visible');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { revealObs.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('tyvexo-social--visible'); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tyvexo-product-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__tyvexoShowcaseReveal) return;
  window.__tyvexoShowcaseReveal = true;

  function init() {
    var els = document.querySelectorAll('.tyvexo-showcase__reveal');
    if (!els.length) return;

    if (!window.IntersectionObserver) {
      els.forEach(function (el) { el.classList.add('tyvexo-showcase--visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tyvexo-showcase--visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { obs.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tyvexo-qa-simple"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initQa() {
    var items = document.querySelectorAll('.tyvexo-qa__item');
    if (!items.length) return;

    items.forEach(function (item) {
      var trigger = item.querySelector('.tyvexo-qa__trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('tyvexo-qa--open');

        items.forEach(function (el) {
          el.classList.remove('tyvexo-qa--open');
          var t = el.querySelector('.tyvexo-qa__trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('tyvexo-qa--open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQa);
  } else {
    initQa();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
